import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { loadRuntimeConfig } from './environments/environment';

import { AppModule } from './app/app.module';

// Load runtime configuration before bootstrapping Angular
loadRuntimeConfig()
  .then(() => {
    platformBrowser()
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
      .catch((err: unknown) => console.error(err));
  })
  .catch((err: unknown) => {
    console.error('Failed to load runtime configuration:', err);
    // Bootstrap anyway with default configuration
    platformBrowser()
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
      .catch((bootstrapErr: unknown) => console.error(bootstrapErr));
  });
